import { BugTrackerPriority, BugTrackerStatus } from '@/types/apiServerContract';

class BugTrackerService {
    public getPriority(priority: BugTrackerPriority) {
        return BugTrackerPriority[priority]?.match(/[A-Z][a-z]+|[0-9]+/g)?.join(' ');
    }

    public getPriorityColor(status: BugTrackerPriority) {
        switch (status) {
        case BugTrackerPriority.None:
            return '#007bff';
        case BugTrackerPriority.Low:
            return '#ffc107';
        case BugTrackerPriority.Medium:
            return '#fd7e14';
        case BugTrackerPriority.High:
            return '#dc3545';
        }
    }

    public getStatus(status: BugTrackerStatus) {
        return BugTrackerStatus[status]?.match(/[A-Z][a-z]+|[0-9]+/g)?.join(' ');
    }

    public getStatusColor(status: BugTrackerStatus) {
        switch (status) {
        case BugTrackerStatus.Pending:
            return '#20c997';
        case BugTrackerStatus.Invalid:
            return '#823131';
        case BugTrackerStatus.Confirmed:
            return '#dca123';
        case BugTrackerStatus.Duplicate:
            return '#fd7e14';
        case BugTrackerStatus.InProgress:
            return '#17a2b8';
        case BugTrackerStatus.WontFix:
            return '#6f42c1';
        case BugTrackerStatus.Fixed:
            return '#70b823';
        case BugTrackerStatus.CantReproduce:
            return '#ffc107';
        }
    }
}

export default new BugTrackerService();
